import { X } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgRemove = mkIcon(X);